let _0x62073b = "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";Function(window["\x61\x74\x6F\x62"](_0x62073b))();

$(document).on("click",".side-cart-btn",function() {
    if($(this).closest('.addcart').find('.variant-id').is('input')){
      var variantId = $(this).closest('.addcart').find('.variant-id').val();
    }else{
      var variantId = $(this).closest('.addcart').find('.variant-id option:selected').val();
    }
    
    var $button = $(this);
    $button.prop('disabled', true).addClass('loading');
    
    $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: variantId,
                quantity: 1
            },
            dataType: 'json',
            success: function(data) {
                // Code to execute after successfully adding to cart
                ajaxCart.load();
                
                // Re-enable button
                $button.prop('disabled', false).removeClass('loading');
                
                // OPEN THE SIDE CART DRAWER
                openSideCartDrawer();
            },
            error: function(error) {
                // Re-enable button
                $button.prop('disabled', false).removeClass('loading');
                
                // Code to execute if there is an error
                alert('There was an issue adding the item to the cart.');
            }
        });
});

// Function to open the side cart drawer
function openSideCartDrawer() {
    console.log('Opening side cart drawer...');
    
    // Try different methods to open the drawer
    
    // Method 1: Add class to body (common pattern)
    $('body').addClass('side-cart-open cart-drawer-open drawer-open overflow-hidden');
    
    // Method 2: Show the side cart directly
    $('#side-cart').show().addClass('active open visible show is-open');
    
    // Method 3: Show overlay if it exists
    $('.side-cart-overlay, .cart-overlay, .drawer-overlay').fadeIn(300).addClass('active');
    
    // Method 4: If there's a specific class from your theme
    $('.drawer-cart').addClass('drawer--active');
    
    // Method 5: Trigger any existing cart function
    if (typeof ajaxCart !== 'undefined' && ajaxCart.load) {
        ajaxCart.load();
    }
    
    // Method 6: Force show by manipulating CSS
    $('#side-cart').css({
        'display': 'block',
        'visibility': 'visible',
        'opacity': 1,
        'transform': 'translateX(0)'
    });
    
    // Method 7: Try to find and click the cart toggle button
    setTimeout(function() {
        $('.cart-toggle, .cart-icon, .header-cart, [href="#cart"]').first().trigger('click');
    }, 100);
}

// Also try to handle the AJAX cart load event
$(document).ajaxComplete(function(event, xhr, settings) {
    if (settings.url && settings.url.indexOf('/cart/add.js') !== -1) {
        console.log('Cart add completed via ajaxComplete');
        setTimeout(openSideCartDrawer, 200);
    }
});

// If you have a cart icon that opens the drawer, we can also monitor that
$(document).on('click', '.cart-icon, .header-cart, .cart-link', function() {
    console.log('Cart icon clicked - checking classes');
    // This helps us see what classes are added when cart opens naturally
});